// ✅ Auto-generated file for C Programming Components

import C_Arithmetic_Operators from "./c_components/C_Arithmetic_Operators .js";
import C_Arrays from "./c_components/C_Arrays .js";
import C_Array_Loops from "./c_components/C_Array_Loops .js";
import C_Array_Size from "./c_components/C_Array_Size .js";
import C_Assignment_Operators from "./c_components/C_Assignment_Operators .js";
import C_auto from "./c_components/C_auto .js";
import C_Basic_Types from "./c_components/C_Basic_Types .js";
import C_Bitwise_Operators from "./c_components/C_Bitwise_Operators .js";
import C_Booleans from "./c_components/C_Booleans .js";
import C_Break_Continue from "./c_components/C_Break_Continue .js";
import C_calloc from "./c_components/C_calloc .js";
import C_Call_Function from "./c_components/C_Call_Function .js";
import C_Certificate from "./c_components/C_Certificate .js";
import C_Code_Blocks from "./c_components/C_Code_Blocks .js";
import C_Comments from "./c_components/C_Comments .js";
import C_Comparison_Operators from "./c_components/C_Comparison_Operators .js";
import C_Compiler from "./c_components/C_Compiler .js";
import C_Constants from "./c_components/C_Constants .js";
import C_Const_Keyword from "./c_components/C_Const_Keyword .js";
import C_Create_Files from "./c_components/C_Create_Files .js";
import C_Create_Function from "./c_components/C_Create_Function .js";
import C_ctype_h from "./c_components/C_ctype_h .js";
import C_Data_Types from "./c_components/C_Data_Types .js";
import C_Date from "./c_components/C_Date .js";
import C_Debugging from "./c_components/C_Debugging .js";
import C_Default_Parameters from "./c_components/C_Default_Parameters .js";
import C_Define_Constants from "./c_components/C_Define_Constants .js";
import C_Dereference from "./c_components/C_Dereference .js";
import C_Do_While from "./c_components/C_Do_While .js";
import C_Else from "./c_components/C_Else .js";
import C_Else_If from "./c_components/C_Else_If .js";
import C_Enums from "./c_components/C_Enums .js";
import C_Errors from "./c_components/C_Errors .js";
import C_Error_Handling from "./c_components/C_Error_Handling .js";
import C_Examples from "./c_components/C_Examples .js";
import C_Exercises from "./c_components/C_Exercises .js";
import C_extern from "./c_components/C_extern .js";
import C_For from "./c_components/C_For .js";
import C_Format_Specifiers from "./c_components/C_Format_Specifiers .js";
import C_Format_Specifiers_Output from "./c_components/C_Format_Specifiers_Output .js";
import C_For_Loop from "./c_components/C_For_Loop .js";
import C_free from "./c_components/C_free .js";
import C_Functions from "./c_components/C_Functions .js";
import C_Function_Declaration from "./c_components/C_Function_Declaration .js";
import C_Function_Parameters from "./c_components/C_Function_Parameters .js";
import C_Gets from "./c_components/C_Gets .js";
import C_Get_Started from "./c_components/C_Get_Started .js";
import C_HOME from "./c_components/C_HOME .js";
import C_IdentifVariable_Names from "./c_components/C_IdentifVariable_Names .js";
import C_If from "./c_components/C_If .js";
import C_If_Else from "./c_components/C_If_Else .js";
import C_Input_Validation from "./c_components/C_Input_Validation .js";
import C_Intro from "./c_components/C_Intro .js";
import C_Keywords from "./c_components/C_Keywords .js";
import C_Logical_Operators from "./c_components/C_Logical_Operators .js";
import C_Macros from "./c_components/C_Macros .js";
import C_malloc from "./c_components/C_malloc .js";
import C_Math_Functions from "./c_components/C_Math_Functions .js";
import C_math_h from "./c_components/C_math_h .js";
import C_Memory_Address from "./c_components/C_Memory_Address .js";
import C_Memory_Management from "./c_components/C_Memory_Management .js";
import C_Multidimensional_Arrays from "./c_components/C_Multidimensional_Arrays .js";
import C_Multiple_Variables from "./c_components/C_Multiple_Variables .js";
import C_Multi_Line_Comments from "./c_components/C_Multi_Line_Comments .js";
import C_Nested_Loops from "./c_components/C_Nested_Loops .js";
import C_New_Lines from "./c_components/C_New_Lines .js";
import C_NULL from "./c_components/C_NULL .js";
import C_Operators from "./c_components/C_Operators .js";
import C_Organize_Code from "./c_components/C_Organize_Code .js";
import C_Output from "./c_components/C_Output .js";
import C_Parameters from "./c_components/C_Parameters .js";
import C_Pointers from "./c_components/C_Pointers .js";
import C_Pointers_Arrays from "./c_components/C_Pointers_Arrays .js";
import C_Pointer_Arithmetic from "./c_components/C_Pointer_Arithmetic .js";
import C_Projects from "./c_components/C_Projects .js";
import C_Quiz from "./c_components/C_Quiz .js";
import C_Read_Files from "./c_components/C_Read_Files .js";
import C_realloc from "./c_components/C_realloc .js";
import C_Real_Life_Examples from "./c_components/C_Real_Life_Examples .js";
import C_Recursion from "./c_components/C_Recursion .js";
import C_Reference from "./c_components/C_Reference .js";
import C_register from "./c_components/C_register .js";
import C_Return_Values from "./c_components/C_Return_Values .js";
import C_Scanf from "./c_components/C_Scanf .js";
import C_Scope from "./c_components/C_Scope .js";
import C_Semicolons from "./c_components/C_Semicolons .js";
import C_Single_Line_Comments from "./c_components/C_Single_Line_Comments .js";
import C_Statements from "./c_components/C_Statements .js";
import C_static from "./c_components/C_static .js";
import C_stdio_h from "./c_components/C_stdio_h .js";
import C_stdlib_h from "./c_components/C_stdlib_h .js";
import C_Storage_Classes from "./c_components/C_Storage_Classes .js";
import C_Strings from "./c_components/C_Strings .js";
import C_String_Functions from "./c_components/C_String_Functions .js";
import C_string_h from "./c_components/C_string_h .js";
import C_Structs_Pointers from "./c_components/C_Structs_Pointers .js";
import C_Structures from "./c_components/C_Structures .js";
import C_Struct_Access from "./c_components/C_Struct_Access .js";
import C_Study_Plan from "./c_components/C_Study_Plan .js";
import C_Switch from "./c_components/C_Switch .js";
import C_Switch_Default from "./c_components/C_Switch_Default .js";
import C_Syllabus from "./c_components/C_Syllabus .js";
import C_Syntax from "./c_components/C_Syntax .js";
import C_Ternary from "./c_components/C_Ternary .js";
import C_time_h from "./c_components/C_time_h .js";
import C_Type_Conversion from "./c_components/C_Type_Conversion .js";
import C_Unions from "./c_components/C_Unions .js";
import C_User_Input from "./c_components/C_User_Input .js";
import C_Variables from "./c_components/C_Variables .js";
import C_Variables_Constants from "./c_components/C_Variables_Constants .js";
import C_Variables_Examples from "./c_components/C_Variables_Examples .js";
import C_Variable_Values from "./c_components/C_Variable_Values .js";
import C_While from "./c_components/C_While .js";
import C_While_Loop from "./c_components/C_While_Loop .js";
import C_Write_Files from "./c_components/C_Write_Files .js";

const AllCProgrammingComponents = {
  "<C_Arithmetic_Operators />": C_Arithmetic_Operators,
  "<C_Arrays />": C_Arrays,
  "<C_Array_Loops />": C_Array_Loops,
  "<C_Array_Size />": C_Array_Size,
  "<C_Assignment_Operators />": C_Assignment_Operators,
  "<C_auto />": C_auto,
  "<C_Basic_Types />": C_Basic_Types,
  "<C_Bitwise_Operators />": C_Bitwise_Operators,
  "<C_Booleans />": C_Booleans,
  "<C_Break_Continue />": C_Break_Continue,
  "<C_calloc />": C_calloc,
  "<C_Call_Function />": C_Call_Function,
  "<C_Certificate />": C_Certificate,
  "<C_Code_Blocks />": C_Code_Blocks,
  "<C_Comments />": C_Comments,
  "<C_Comparison_Operators />": C_Comparison_Operators,
  "<C_Compiler />": C_Compiler,
  "<C_Constants />": C_Constants,
  "<C_Const_Keyword />": C_Const_Keyword,
  "<C_Create_Files />": C_Create_Files,
  "<C_Create_Function />": C_Create_Function,
  "<C_ctype_h />": C_ctype_h,
  "<C_Data_Types />": C_Data_Types,
  "<C_Date />": C_Date,
  "<C_Debugging />": C_Debugging,
  "<C_Default_Parameters />": C_Default_Parameters,
  "<C_Define_Constants />": C_Define_Constants,
  "<C_Dereference />": C_Dereference,
  "<C_Do_While />": C_Do_While,
  "<C_Else />": C_Else,
  "<C_Else_If />": C_Else_If,
  "<C_Enums />": C_Enums,
  "<C_Errors />": C_Errors,
  "<C_Error_Handling />": C_Error_Handling,
  "<C_Examples />": C_Examples,
  "<C_Exercises />": C_Exercises,
  "<C_extern />": C_extern,
  "<C_For />": C_For,
  "<C_Format_Specifiers />": C_Format_Specifiers,
  "<C_Format_Specifiers_Output />": C_Format_Specifiers_Output,
  "<C_For_Loop />": C_For_Loop,
  "<C_free />": C_free,
  "<C_Functions />": C_Functions,
  "<C_Function_Declaration />": C_Function_Declaration,
  "<C_Function_Parameters />": C_Function_Parameters,
  "<C_Gets />": C_Gets,
  "<C_Get_Started />": C_Get_Started,
  "<C_HOME />": C_HOME,
  "<C_IdentifVariable_Names />": C_IdentifVariable_Names,
  "<C_If />": C_If,
  "<C_If_Else />": C_If_Else,
  "<C_Input_Validation />": C_Input_Validation,
  "<C_Intro />": C_Intro,
  "<C_Keywords />": C_Keywords,
  "<C_Logical_Operators />": C_Logical_Operators,
  "<C_Macros />": C_Macros,
  "<C_malloc />": C_malloc,
  "<C_Math_Functions />": C_Math_Functions,
  "<C_math_h />": C_math_h,
  "<C_Memory_Address />": C_Memory_Address,
  "<C_Memory_Management />": C_Memory_Management,
  "<C_Multidimensional_Arrays />": C_Multidimensional_Arrays,
  "<C_Multiple_Variables />": C_Multiple_Variables,
  "<C_Multi_Line_Comments />": C_Multi_Line_Comments,
  "<C_Nested_Loops />": C_Nested_Loops,
  "<C_New_Lines />": C_New_Lines,
  "<C_NULL />": C_NULL,
  "<C_Operators />": C_Operators,
  "<C_Organize_Code />": C_Organize_Code,
  "<C_Output />": C_Output,
  "<C_Parameters />": C_Parameters,
  "<C_Pointers />": C_Pointers,
  "<C_Pointers_Arrays />": C_Pointers_Arrays,
  "<C_Pointer_Arithmetic />": C_Pointer_Arithmetic,
  "<C_Projects />": C_Projects,
  "<C_Quiz />": C_Quiz,
  "<C_Read_Files />": C_Read_Files,
  "<C_realloc />": C_realloc,
  "<C_Real_Life_Examples />": C_Real_Life_Examples,
  "<C_Recursion />": C_Recursion,
  "<C_Reference />": C_Reference,
  "<C_register />": C_register,
  "<C_Return_Values />": C_Return_Values,
  "<C_Scanf />": C_Scanf,
  "<C_Scope />": C_Scope,
  "<C_Semicolons />": C_Semicolons,
  "<C_Single_Line_Comments />": C_Single_Line_Comments,
  "<C_Statements />": C_Statements,
  "<C_static />": C_static,
  "<C_stdio_h />": C_stdio_h,
  "<C_stdlib_h />": C_stdlib_h,
  "<C_Storage_Classes />": C_Storage_Classes,
  "<C_Strings />": C_Strings,
  "<C_String_Functions />": C_String_Functions,
  "<C_string_h />": C_string_h,
  "<C_Structs_Pointers />": C_Structs_Pointers,
  "<C_Structures />": C_Structures,
  "<C_Struct_Access />": C_Struct_Access,
  "<C_Study_Plan />": C_Study_Plan,
  "<C_Switch />": C_Switch,
  "<C_Switch_Default />": C_Switch_Default,
  "<C_Syllabus />": C_Syllabus,
  "<C_Syntax />": C_Syntax,
  "<C_Ternary />": C_Ternary,
  "<C_time_h />": C_time_h,
  "<C_Type_Conversion />": C_Type_Conversion,
  "<C_Unions />": C_Unions,
  "<C_User_Input />": C_User_Input,
  "<C_Variables />": C_Variables,
  "<C_Variables_Constants />": C_Variables_Constants,
  "<C_Variables_Examples />": C_Variables_Examples,
  "<C_Variable_Values />": C_Variable_Values,
  "<C_While />": C_While,
  "<C_While_Loop />": C_While_Loop,
  "<C_Write_Files />": C_Write_Files,
};

export default AllCProgrammingComponents;
